module.exports = __webpack_public_path__ + "img/Parrot.28b6c049.png";